// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== DetailCandidature ===================================================== */

.candidature-detail-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f9fafb;
}

/* Page en pleine largeur (bleed, banniere SuiviHeader) : le corps reinjecte les marges
   laterales (comme les pages de suivi) -> le contenu n'est pas colle aux bords. */
.candidature-detail-container .suivi-de-commande-content {
  padding: 0 6rem;
}

/* ── Skeleton de chargement : silhouette de la page (banniere SuiviHeader + onglets + blocs).
   Reprend le skeleton suivi commande ; geometrie de la banniere calee sur SuiviHeader. ── */
.cand-skeleton {
  pointer-events: none;
}
.cand-sk {
  display: block;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: cand-sk-shimmer 1.4s ease-in-out infinite;
  border-radius: 6px;
}
@keyframes cand-sk-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Banniere : meme geometrie que SuiviHeader (padding 2rem 6rem, marge basse 2rem, fond sombre). */
.cand-sk-banner {
  padding: 2rem 6rem;
  margin-bottom: 2rem;
  background: #1f2937;
}
.cand-sk-banner .cand-sk {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);
  background-size: 200% 100%;
}
.cand-sk-back { padding: 1rem 0; }
.cand-sk-back .cand-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }
.cand-sk-h1 { height: 4.1rem; display: flex; align-items: center; }
.cand-sk-h1 .cand-sk { width: 45%; height: 2.4rem; }
.cand-sk-h2 { height: 3.1rem; display: flex; align-items: center; }
.cand-sk-h2 .cand-sk { width: 32%; height: 1.8rem; }
.cand-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }
.cand-sk-subtitle .cand-sk { width: 38%; height: 1.4rem; }
.cand-sk-statusline { height: 2rem; display: flex; align-items: center; }
.cand-sk-statusline .cand-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }

/* Barre d'onglets (mime .tab-nav ; le corps n'ayant pas de padding haut, on ajoute 2rem). */
.cand-sk-tabs {
  display: flex;
  gap: 2rem;
  border-bottom: 1px solid #e5e7eb;
  padding: 2rem 1rem 1rem;
  margin-bottom: 3rem;
}
.cand-sk-tab { width: 110px; height: 18px; }

/* Zone de contenu : blocs empiles. */
.cand-sk-content {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding: 0 1rem 2rem;
}
.cand-sk-block { width: 100%; height: 90px; }
.cand-sk-block--lg { height: 220px; }

/* ── Contenu onglet ──────────────────────────────────────────────────────── */

.candidature-tab-content {
  flex: 1 1;
  padding: 2rem 2.4rem 120px 2.4rem;
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  box-sizing: border-box;
}

@media screen and (max-width: 768px) {
  .candidature-tab-content {
    padding: 1rem 1rem 120px 1rem;
  }
}

/* ── Section block (legacy compat — prefer SectionBlock component) ──────── */

.section-block {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.section-header-dark {
  background-color: #374151;
  color: #ffffff;
  padding: 1.2rem 1.6rem;
  font-weight: 600;
  font-size: 1.4rem;
  letter-spacing: 0.01em;
}

.section-content {
  padding: 1.6rem 2rem;
}

/* Override pour que le dropdown lots dépasse la section */
.section-content--overflow-visible {
  overflow: visible !important;
}

.section-empty {
  padding: 2rem;
  color: #9ca3af;
  font-size: 1.4rem;
  text-align: center;
}

.section-footer-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.2rem;
  /* border-top: 1px solid #f3f4f6; */
}

/* ── Mandataire card (horizontal layout per maquette) ─────────────────── */

.mandataire-card > * > button,
.groupement-footer > button {
  border-radius: 8px !important;
}

.mandataire-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.2rem;
  padding: 1.2rem 2rem;
  /* border-bottom: 1px solid #f3f4f6; */
  flex-wrap: wrap;
}

.mandataire-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
  font-size: 1.3rem;
  color: #374151;
  margin-bottom: 2rem;
}

.mandataire-profil-button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.view-profile-button {
  background-color: #374151;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 16px 8px;
  cursor: pointer;
  width: 80%;
  height: 3.5rem;
  white-space: nowrap;
  margin-left: auto;
  margin-right: auto;
}

.delete-member-button,
.delete-member-button:hover,
.delete-member-button > * {
  cursor: pointer !important;
}

.delete-member-button > * {
  margin: 0 !important;
}

.mandataire-name {
  font-weight: 600;
  font-size: 1.4rem;
  color: #111827;
}

.mandataire-field {
  font-size: 1.3rem;
  color: #374151;
}

/* ── ProfilProgressBar ──────────────────────────────────────────────────── */

.profil-progress-wrapper {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-width: 120px;
}

.profil-progress-bar {
  flex: 1 1;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.profil-progress-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s;
}

.profil-progress-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
  min-width: 36px;
  text-align: right;
}

/* ── Cotraitants table ────────────────────────────────────────────────────── */

.cotraitants-table-wrapper {
  overflow-x: auto;
}

.cotraitants-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.3rem;
}

.cotraitants-table thead tr {
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.cotraitants-table th {
  padding: 0.8rem 1rem;
  text-align: left;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
  font-size: 1.2rem;
}

.cotraitants-table tbody tr {
  /* border-bottom: 1px solid #f3f4f6; */
  transition: background-color 0.15s;
}

.cotraitants-table tbody tr:hover {
  background-color: #fdf4ef;
}

.cotraitants-table td {
  padding: 0.8rem 1rem;
  color: #374151;
  vertical-align: middle;
  font-size: 1.3rem;
}

.cotraitants-table td.td-entreprise {
  font-weight: 500;
}

.cotraitants-table td.td-siret {
  font-family: "Courier New", Courier, monospace;
}

.cotraitants-table td.td-email {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cotraitants-table td.td-actions {
  text-align: center;
}

.btn-delete-cotraitant {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  font-size: 1.6rem;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  transition: background 0.15s;
}

.btn-delete-cotraitant:hover {
  background: #fef2f2;
}

.retirer-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.4rem;
  color: #ef4444;
  padding: 0.2rem;
  transition: opacity 0.15s;
}

.retirer-btn:hover {
  opacity: 0.7;
}

/* ── Groupement footer ───────────────────────────────────────────────────── */

.groupement-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.2rem;
  border-top: 1px solid #f3f4f6;
  flex-wrap: wrap;
}

.convention-inline {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  flex: 1 1;
  min-width: 0;
}

.convention-inline > .button {
  align-self: flex-start;
}

/* ── Bloc convention de groupement ──────────────────────────────────────── */

.convention-bloc {
  padding: 1.2rem 0;
  margin: 0 0 0.75rem 0;
  border-top: 1px solid #f3f4f6;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.convention-bloc-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
}

.required-star {
  color: #ef4444;
  font-size: 1.4rem;
}

.convention-model-link {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 1.2rem;
  color: #f97316;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.convention-model-link:hover {
  color: #ea6d0a;
}

.convention-doc-area {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.convention-doc-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.8rem 1.2rem;
  background-color: rgba(215, 217, 217, 0.2);
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  transition:
    transform 0.15s,
    box-shadow 0.15s,
    background-color 0.15s;
  min-width: 220px;
}

.convention-doc-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  background-color: rgba(215, 217, 217, 0.35);
}

.convention-doc-icon {
  font-size: 1.8rem;
  flex-shrink: 0;
}

.convention-doc-info {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.convention-doc-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  word-break: break-all;
}

.convention-doc-date {
  font-size: 1.1rem;
  color: #6b7280;
  font-style: italic;
}

.convention-buttons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-right: auto;
}

.convention-groupement-hint {
  font-size: 0.8rem;
  color: #9ca3af;
}

.convention-signee-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  background-color: #dcfce7;
  color: #16a34a;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 0.3rem 0.8rem;
  border-radius: 50px;
}

.convention-groupement-filename {
  font-size: 0.875rem;
  color: #374151;
  font-weight: 500;
}

.convention-groupement-file-input {
  display: none;
}

/* ── Preview modal convention signée ────────────────────────────────────── */

.convention-preview-panel {
  background: #ffffff;
  border-radius: 10px;
  width: 90vw;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.convention-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.convention-preview-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #111827;
  word-break: break-all;
}

.convention-preview-iframe {
  flex: 1 1;
  border: none;
  min-height: 60vh;
}

.convention-preview-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.choix-lots-field {
  padding: 1.2rem 1.5rem;
  /* border-bottom: 1px solid #f3f4f6; */
  position: relative;
  z-index: 10;
  overflow: visible;
}

.choix-lots-field:last-child {
  border-bottom: none;
}

.field-label {
  display: block;
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.75rem;
}

.select-field {
  width: 100%;
  max-width: 400px;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 1.4rem;
  color: #374151;
  background: #ffffff;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.select-field:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.select-disabled {
  background: #f9fafb;
  cursor: not-allowed;
  color: #6b7280;
}

/* ── Dropdown lots géographiques ─────────────────────────────────────── */

.lots-dropdown {
  position: relative;
}

.lots-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 400px;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 1.4rem;
  color: #374151;
  background: #ffffff;
  cursor: pointer;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.lots-dropdown-trigger:hover {
  border-color: #f97316;
}

.lots-dropdown-trigger:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.lots-geo-list {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 2px;
  max-height: 420px;
  overflow-y: auto;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0.75rem;
  background: #ffffff;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.lots-geo-list-disabled {
  background: #f9fafb;
  cursor: not-allowed;
}

.lot-geo-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.4rem;
  color: #374151;
  cursor: pointer;
}

.lot-geo-option input[type="checkbox"] {
  width: 14px;
  height: 14px;
  accent-color: #f97316;
}

.lots-count {
  font-size: 1.3rem;
  color: #6b7280;
  margin: 3.5rem 0 0.5rem 0;
}

.lots-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.lot-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  font-size: 1.2rem;
  font-weight: 500;
  white-space: nowrap;
  transition: background-color 0.15s;
}

.lot-chip:hover {
  background-color: #e5e7eb;
}

.lot-chip-remove {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0 0.1rem;
  line-height: 1;
  font-weight: 700;
  transition: color 0.15s;
}

.lot-chip-remove:hover {
  color: #ef4444;
}

/* ── Lots géo — groupement région (lot 1xx) ──────────────────────────────── */

.lot-geo-option-all {
  font-weight: 600;
  /* border-bottom: 1px solid #f3f4f6; */
  padding-bottom: 0.5rem;
  margin-bottom: 0.25rem;
}

.lots-geo-region-group {
  /* border-bottom: 1px solid #f3f4f6; */
  padding-bottom: 0.25rem;
  margin-bottom: 0.25rem;
}

.lots-geo-region-group:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.lots-geo-region-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  padding: 0.35rem 0;
}

.lots-geo-region-header input[type="checkbox"] {
  width: 14px;
  height: 14px;
  accent-color: #f97316;
  flex-shrink: 0;
}

.lots-geo-region-nom {
  flex: 1 1;
}

.lots-geo-region-count {
  font-size: 1.2rem;
  font-weight: 400;
  color: #9ca3af;
}

.lots-geo-region-body {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.lots-geo-region-indent {
  padding-left: 1.75rem;
  font-size: 1.3rem;
  color: #6b7280;
}

/* ── Offre technique ──────────────────────────────────────────────────────── */

.critere-block {
  display: flex;
  flex-direction: column;
  padding: 1.2rem 1.5rem;
  /* border-bottom: 1px solid #f3f4f6; */
}

.critere-block:last-of-type {
  border-bottom: none;
}

.critere-label {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  display: block;
  margin-bottom: 0.8rem;
}

.critere-textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1.4rem;
  color: #374151;
  background-color: #ffffff;
  resize: vertical;
  font-family: inherit;
  line-height: 1.6;
  box-sizing: border-box;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.critere-textarea:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.critere-textarea-disabled {
  background: #f9fafb;
  cursor: not-allowed;
  color: #6b7280;
}

.char-counter {
  display: block;
  text-align: right;
  font-size: 1.2rem;
  color: #9ca3af;
  margin-top: 0.25rem;
}

/* ── Commission warning ──────────────────────────────────────────────────── */

.commission-warning {
  margin: 1.25rem 1.5rem;
  padding: 1.2rem 1.6rem;
  background-color: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  font-size: 1.3rem;
  color: #92400e;
  line-height: 1.6;
}

/* ── Toggle prix identiques ──────────────────────────────────────────────── */

.prix-toggle-wrapper {
  padding: 1rem 1.5rem;
  /* border-bottom: 1px solid #f3f4f6; */
}

.prix-toggle-label {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.4rem;
  color: #374151;
}

.prix-toggle-input {
  width: 16px;
  height: 16px;
  accent-color: #f97316;
  cursor: pointer;
}

/* ── Articles table ──────────────────────────────────────────────────────── */

.candidature-detail-container .articles-table-wrapper {
  overflow-x: auto;
  padding: 1.2rem 1.5rem;
}

.candidature-detail-container .articles-table {
  min-width: 1200px;
  width: 100%;
  border-collapse: collapse;
  font-size: 1.3rem;
}

.candidature-detail-container .articles-table thead tr {
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.candidature-detail-container .articles-table th {
  padding: 0.8rem 1rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  vertical-align: bottom;
}

/* Colonnes Prix : autoriser le retour à la ligne */
.candidature-detail-container .articles-table th:nth-child(7),
.candidature-detail-container .articles-table th:nth-child(8),
.candidature-detail-container .articles-table th:nth-child(9) {
  white-space: normal;
  min-width: 120px;
  text-align: center;
}

.candidature-detail-container .articles-table th small {
  font-weight: 400;
  color: #6b7280;
  font-size: 1.1rem;
}

.candidature-detail-container .articles-table td {
  padding: 0.8rem 1rem;
  color: #374151;
  vertical-align: middle;
  white-space: nowrap;
}

/* Colonne Ref : compacte */
.candidature-detail-container .articles-table th:nth-child(1),
.candidature-detail-container .articles-table td:nth-child(1) {
  width: 2.5rem;
  text-align: center;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}

/* Colonne Article : prend l'espace restant, tronque si trop long */
.candidature-detail-container .articles-table th:nth-child(2) {
  white-space: normal;
}

.candidature-detail-container .articles-table td:nth-child(2) {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Colonne Description : ajustée au bouton */
.candidature-detail-container .articles-table th:nth-child(3),
.candidature-detail-container .articles-table td:nth-child(3) {
  width: 130px;
  min-width: 130px;
  text-align: center;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}

/* Colonnes Seuil A, Seuil B : compactes */
.candidature-detail-container .articles-table th:nth-child(4),
.candidature-detail-container .articles-table td:nth-child(4),
.candidature-detail-container .articles-table th:nth-child(5),
.candidature-detail-container .articles-table td:nth-child(5) {
  width: 75px;
  min-width: 75px;
  text-align: center;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}

/* Colonne Unité : compacte */
.candidature-detail-container .articles-table th:nth-child(6),
.candidature-detail-container .articles-table td:nth-child(6) {
  width: 65px;
  min-width: 65px;
  text-align: center;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}

.candidature-detail-container .articles-table tbody tr {
  /* border-bottom: 1px solid #f3f4f6; */
}

.candidature-detail-container .articles-table tbody tr:hover {
  background-color: #fdf4ef;
}

.prix-input {
  width: 80px;
  padding: 4px 6px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 1.2rem;
  color: #374151;
  text-align: right;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.prix-input:disabled {
  background: #f9fafb;
  cursor: not-allowed;
  color: #9ca3af;
}

.prix-input:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

/* Cellule prix : input + € */
.prix-input-cell {
  display: flex;
  align-items: center;
  gap: 4px;
}

.prix-input-cell__suffix {
  color: #6b7280;
  font-size: 1.2rem;
}

/* ── Accordéon ───────────────────────────────────────────────────────────── */

/* ── Bouton "Voir les détails" (colonne Description) ─────────────────────── */

.btn-voir-details {
  background-color: #595959;
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 1.2rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s;
}

.btn-voir-details:hover {
  background-color: #1f2937;
}

/* ── Accordéon ───────────────────────────────────────────────────────────── */

.accordeons-list {
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.accordion {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}

.accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background: #ffffff;
  border: none;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
  width: 100%;
  text-align: left;
  transition: background-color 0.15s;
}

.accordion-header:hover {
  background-color: #fdf4ef;
}

/* Chevron icône dans accordéon */
.accordion-chevron {
  width: 20px;
  height: 20px;
  fill: #6b7280;
  transition: transform 0.25s ease;
  flex-shrink: 0;
}

.accordion-chevron--open {
  transform: rotate(180deg);
}

.accordion-body {
  /* border-top: 1px solid #e5e7eb; */
  background: #fcfcfc;
}

/* ── Modal (réutilisation des styles de DashboardCandidatures) ─────────── */

.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-panel {
  background: #ffffff;
  border-radius: 10px;
  width: 100%;
  max-width: 640px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.4rem 1.8rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  font-size: 1.8rem;
  font-weight: 600;
  color: #1f2937;
}

.modal-body {
  overflow-y: auto;
  padding: 1.4rem 1.8rem;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 1.2rem 1.8rem;
  border-top: 1px solid #e5e7eb;
}

/* ── Inviter Modal (Story 8.5) ──────────────────────────────────────────── */

.inviter-modal {
  max-width: 580px;
}

.inviter-modal .modal-body {
  overflow: visible;
}

.inviter-error {
  background: #fef2f2;
  border: 1px solid #fca5a5;
  color: #b91c1c;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 1.3rem;
  margin-bottom: 1rem;
}

.inviter-section-label {
  display: block;
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.inviter-search-wrapper {
  position: relative;
  margin-bottom: 1rem;
}

.inviter-search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1.3rem;
  color: #374151;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  transition: border-color 0.15s;
}

.inviter-search-input:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.inviter-search-spinner {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: inviterSpin 0.7s linear infinite;
  pointer-events: none;
}

.inviter-search-results {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  max-height: 200px;
  overflow-y: auto;
}

.inviter-search-result-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 14px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 1.3rem;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  transition: background 0.12s;
}

.inviter-search-result-item:hover {
  background: #fff7ed;
}

.inviter-result-nom {
  font-size: 1.3rem;
  color: #374151;
  font-weight: 500;
}

.inviter-result-siret {
  font-size: 1.1rem;
  color: #9ca3af;
  margin-left: auto;
  font-family: monospace;
}

.inviter-search-empty {
  padding: 10px 14px;
  font-size: 1.3rem;
  color: #9ca3af;
}

.inviter-membres-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 0.5rem;
}

.inviter-membres-count {
  font-size: 1.2rem;
  color: #6b7280;
  margin: 0 0 4px;
}

.inviter-membre-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.inviter-membre-nom {
  font-size: 1.3rem;
  color: #374151;
  font-weight: 500;
  flex: 1 1;
}

.inviter-membre-siret {
  font-size: 1.1rem;
  color: #9ca3af;
  font-family: monospace;
}

.inviter-membre-remove {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #9ca3af;
  padding: 0 4px;
  border-radius: 4px;
  transition:
    color 0.15s,
    background 0.15s;
  flex-shrink: 0;
}

.inviter-membre-remove:hover {
  color: #dc2626;
  background: #fef2f2;
}

@keyframes inviterSpin {
  from {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(360deg);
  }
}

/* ── Statut membre groupement ────────────────────────────────────────────── */

.member-status {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 1.2rem;
  font-weight: 500;
  white-space: nowrap;
}

.member-status--accepted {
  background: #dcfce7;
  color: #166534;
}

.member-status--pending {
  background: #fef3c7;
  color: #92400e;
}

/* ── Loading / Error ─────────────────────────────────────────────────────── */

.detail-loading,
.detail-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  gap: 1rem;
  color: #6b7280;
  font-size: 1.3rem;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ── Placeholder onglets non implémentés ─────────────────────────────────── */

.tab-placeholder {
  text-align: center;
  padding: 4rem;
  color: #9ca3af;
  font-size: 1.4rem;
  background: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 0.5rem;
  margin: 0;
}

/* ── Soumission (Story 8.9) ──────────────────────────────────────────────── */

.soumission-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.soumission-badge-soumise {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #dcfce7;
  color: #15803d;
  font-weight: 600;
  font-size: 1.3rem;
  padding: 0.75rem 1.25rem;
  border-radius: 0.5rem;
  border: 1px solid #bbf7d0;
}

.soumission-block {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 1rem 1.25rem;
}

.soumission-block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.soumission-block-title {
  font-weight: 600;
  font-size: 1.3rem;
  color: #374151;
}

.soumission-profils-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.soumission-profil-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  padding: 0.4rem 0.75rem;
  border-radius: 0.375rem;
}

.soumission-profil-item.ok {
  background: #f0fdf4;
  color: #166534;
}

.soumission-profil-item.ko {
  background: #fef2f2;
  color: #991b1b;
}

.soumission-profil-nom {
  flex: 1 1;
}

.soumission-profil-pct {
  font-weight: 600;
  min-width: 3rem;
  text-align: right;
}

.soumission-profil-icon {
  font-weight: 700;
  font-size: 1.1rem;
  min-width: 1.2rem;
  text-align: center;
}

/* ── Feedback inline après sauvegarde ───────────────────────────────────── */

/* ── Section Génération du contrat (placeholder) ─────────────────────────── */

.generation-contrat-placeholder {
  min-height: 80px;
  background-color: #f9fafb;
  border-radius: 6px;
}

/* ── Feedback inline après sauvegarde ───────────────────────────────────── */

.save-msg {
  font-size: 1.15rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  border-radius: 0.375rem;
  animation: fadeInOut 3s ease forwards;
}

.save-msg-ok {
  color: #166534;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.save-msg-err {
  color: #991b1b;
  background: #fef2f2;
  border: 1px solid #fca5a5;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(-4px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* ── Checklist pré-soumission ───────────────────────────────────────────── */

.soumission-checklist {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.soumission-check-item {
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
  font-size: 1.25rem;
  padding: 0.4rem 0.75rem;
  border-radius: 0.375rem;
}

.soumission-check-item.ok {
  background: #f0fdf4;
  color: #166534;
}

.soumission-check-item.ko {
  background: #fef2f2;
  color: #991b1b;
}

.soumission-check-item.loading {
  background: #f3f4f6;
  color: #6b7280;
}

.soumission-check-icon {
  font-weight: 700;
  font-size: 1.1rem;
  min-width: 1.2rem;
  text-align: center;
  flex-shrink: 0;
}

.soumission-check-label {
  font-weight: 600;
  flex-shrink: 0;
}

.soumission-check-detail {
  font-size: 1.1rem;
  opacity: 0.8;
}

.soumission-alert {
  color: #b91c1c;
  font-size: 1.2rem;
  background: #fef2f2;
  border: 1px solid #fca5a5;
  border-radius: 0.375rem;
  padding: 0.6rem 1rem;
  margin: 0;
}

.soumission-conditions {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 1.3rem;
  color: #374151;
  cursor: pointer;
  line-height: 1.5;
}

.soumission-conditions input[type="checkbox"] {
  margin-top: 0.2rem;
  width: 1.1rem;
  height: 1.1rem;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #f97316;
}

.cgu-link {
  background: none;
  border: none;
  padding: 0;
  color: #f97316;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
}

.cgu-link:hover {
  color: #ea580c;
}

.cgu-required-star {
  color: #ef4444;
  font-weight: 700;
}

.tab-content {
  gap: 2rem;
  padding: 2rem 0;
}

/* ===== Story 13.6 — Détection prix manquants ============================= */

.article-row--incomplete {
  border-left: 3px solid #ef4444;
  background-color: #fef2f2;
}

.prix-completion-counter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 1rem;
  padding: 0.5rem 0.75rem;
  background: #f9fafb;
  border-radius: 0.375rem;
}

.prix-manquants {
  color: #ef4444;
  font-weight: 500;
}

.btn-scroll-manquant {
  background: none;
  border: none;
  color: #3b82f6;
  cursor: pointer;
  font-size: 0.85rem;
  text-decoration: underline;
  padding: 0;
}

.accordion-badge {
  font-size: 1.2rem;
  margin-left: auto;
  margin-right: 0.5rem;
  font-weight: 500;
}

/* ── Forfait & prix dégressifs ───────────────────────────────────────────── */

.article-row--warning {
  border-left: 3px solid #f59e0b;
  background-color: #fffbeb;
}

.article-row--error {
  border-left: 3px solid #ef4444;
  background-color: #fef2f2;
}

.prix-input--warning {
  border-color: #f59e0b !important;
  background-color: #fffbeb !important;
}

.prix-input--error {
  border-color: #ef4444 !important;
  background-color: #fef2f2 !important;
}

/* Input nom signataire (popup dépôt) */
.nom-signataire-input {
  width: 100%;
  padding: 0.4rem 0.6rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1.2rem;
  color: #374151;
}

.nom-signataire-input:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);
}

/* Bandeau d'etat d'une candidature annulee.
   La largeur vient de son parent (.suivi-de-commande-content) : la banniere est
   rendue DANS le conteneur des sections, elle n'a donc aucune geometrie propre.
   Il ne reste qu'un espacement vertical. */
/* Bandeau d'etat en tete des sections (annulation, depot hors delai).
   Ne porte QUE l'espacement : la largeur vient du conteneur parent
   .suivi-de-commande-content, jamais d'une constante recopiee ici. */
.candidature-etat-banner {
  margin-top: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DetailCandidature/DetailCandidature.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;kFACkF;AAClF;EACE,eAAe;AACjB;;AAEA;4FAC4F;AAC5F;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,yEAAyE;EACzE,0BAA0B;EAC1B,oDAAoD;EACpD,kBAAkB;AACpB;AACA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,kGAAkG;AAClG;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,+HAA+H;EAC/H,0BAA0B;AAC5B;AACA,gBAAgB,eAAe,EAAE;AACjC,gCAAgC,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACnF,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;AACnD,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;AACnD,oBAAoB,cAAc,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC7F,6BAA6B,UAAU,EAAE,cAAc,EAAE;AACzD,sBAAsB,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACxE,+BAA+B,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAElF,4FAA4F;AAC5F;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;AACrB;AACA,eAAe,YAAY,EAAE,YAAY,EAAE;;AAE3C,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;AACtB;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,qBAAqB,aAAa,EAAE;;AAEpC,+EAA+E;;AAE/E;EACE,SAAO;EACP,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA,8EAA8E;;AAE9E;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA,4EAA4E;;AAE5E;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,gFAAgF;;AAEhF;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8EAA8E;;AAE9E;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB;;;0BAGwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,8EAA8E;;AAE9E;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2EAA2E;;AAE3E;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf;;mBAEiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,sCAAsC;EACtC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;;;EAGE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,mEAAmE;AACnE;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4CAA4C;AAC5C;;EAEE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;;;;EAIE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB;;mBAEiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,+EAA+E;;AAE/E,+EAA+E;;AAE/E;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+EAA+E;;AAE/E;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,6EAA6E;;AAE7E;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,8EAA8E;;AAE9E;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd;;;;;cAKY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB;;;;;cAKY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB;;oBAEkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA,+EAA+E;;AAE/E;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,SAAS;AACX;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8EAA8E;;AAE9E,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,8EAA8E;;AAE9E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,8EAA8E;;AAE9E;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,8EAA8E;;AAE9E;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;;2CAG2C;AAC3C;;qEAEqE;AACrE;EACE,kBAAkB;AACpB","sourcesContent":["/* ===== DetailCandidature ===================================================== */\n\n.candidature-detail-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: #f9fafb;\n}\n\n/* Page en pleine largeur (bleed, banniere SuiviHeader) : le corps reinjecte les marges\n   laterales (comme les pages de suivi) -> le contenu n'est pas colle aux bords. */\n.candidature-detail-container .suivi-de-commande-content {\n  padding: 0 6rem;\n}\n\n/* ── Skeleton de chargement : silhouette de la page (banniere SuiviHeader + onglets + blocs).\n   Reprend le skeleton suivi commande ; geometrie de la banniere calee sur SuiviHeader. ── */\n.cand-skeleton {\n  pointer-events: none;\n}\n.cand-sk {\n  display: block;\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: cand-sk-shimmer 1.4s ease-in-out infinite;\n  border-radius: 6px;\n}\n@keyframes cand-sk-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* Banniere : meme geometrie que SuiviHeader (padding 2rem 6rem, marge basse 2rem, fond sombre). */\n.cand-sk-banner {\n  padding: 2rem 6rem;\n  margin-bottom: 2rem;\n  background: #1f2937;\n}\n.cand-sk-banner .cand-sk {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);\n  background-size: 200% 100%;\n}\n.cand-sk-back { padding: 1rem 0; }\n.cand-sk-back .cand-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }\n.cand-sk-h1 { height: 4.1rem; display: flex; align-items: center; }\n.cand-sk-h1 .cand-sk { width: 45%; height: 2.4rem; }\n.cand-sk-h2 { height: 3.1rem; display: flex; align-items: center; }\n.cand-sk-h2 .cand-sk { width: 32%; height: 1.8rem; }\n.cand-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }\n.cand-sk-subtitle .cand-sk { width: 38%; height: 1.4rem; }\n.cand-sk-statusline { height: 2rem; display: flex; align-items: center; }\n.cand-sk-statusline .cand-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }\n\n/* Barre d'onglets (mime .tab-nav ; le corps n'ayant pas de padding haut, on ajoute 2rem). */\n.cand-sk-tabs {\n  display: flex;\n  gap: 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 2rem 1rem 1rem;\n  margin-bottom: 3rem;\n}\n.cand-sk-tab { width: 110px; height: 18px; }\n\n/* Zone de contenu : blocs empiles. */\n.cand-sk-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n  padding: 0 1rem 2rem;\n}\n.cand-sk-block { width: 100%; height: 90px; }\n.cand-sk-block--lg { height: 220px; }\n\n/* ── Contenu onglet ──────────────────────────────────────────────────────── */\n\n.candidature-tab-content {\n  flex: 1;\n  padding: 2rem 2.4rem 120px 2.4rem;\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  box-sizing: border-box;\n}\n\n@media screen and (max-width: 768px) {\n  .candidature-tab-content {\n    padding: 1rem 1rem 120px 1rem;\n  }\n}\n\n/* ── Section block (legacy compat — prefer SectionBlock component) ──────── */\n\n.section-block {\n  background: #ffffff;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n}\n\n.section-header-dark {\n  background-color: #374151;\n  color: #ffffff;\n  padding: 1.2rem 1.6rem;\n  font-weight: 600;\n  font-size: 1.4rem;\n  letter-spacing: 0.01em;\n}\n\n.section-content {\n  padding: 1.6rem 2rem;\n}\n\n/* Override pour que le dropdown lots dépasse la section */\n.section-content--overflow-visible {\n  overflow: visible !important;\n}\n\n.section-empty {\n  padding: 2rem;\n  color: #9ca3af;\n  font-size: 1.4rem;\n  text-align: center;\n}\n\n.section-footer-right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1rem 1.2rem;\n  /* border-top: 1px solid #f3f4f6; */\n}\n\n/* ── Mandataire card (horizontal layout per maquette) ─────────────────── */\n\n.mandataire-card > * > button,\n.groupement-footer > button {\n  border-radius: 8px !important;\n}\n\n.mandataire-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 1.2rem;\n  padding: 1.2rem 2rem;\n  /* border-bottom: 1px solid #f3f4f6; */\n  flex-wrap: wrap;\n}\n\n.mandataire-info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1.2rem;\n  flex-wrap: wrap;\n  font-size: 1.3rem;\n  color: #374151;\n  margin-bottom: 2rem;\n}\n\n.mandataire-profil-button {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.view-profile-button {\n  background-color: #374151;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 16px 8px;\n  cursor: pointer;\n  width: 80%;\n  height: 3.5rem;\n  white-space: nowrap;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.delete-member-button,\n.delete-member-button:hover,\n.delete-member-button > * {\n  cursor: pointer !important;\n}\n\n.delete-member-button > * {\n  margin: 0 !important;\n}\n\n.mandataire-name {\n  font-weight: 600;\n  font-size: 1.4rem;\n  color: #111827;\n}\n\n.mandataire-field {\n  font-size: 1.3rem;\n  color: #374151;\n}\n\n/* ── ProfilProgressBar ──────────────────────────────────────────────────── */\n\n.profil-progress-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  min-width: 120px;\n}\n\n.profil-progress-bar {\n  flex: 1;\n  height: 8px;\n  background-color: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.profil-progress-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.3s;\n}\n\n.profil-progress-label {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #374151;\n  min-width: 36px;\n  text-align: right;\n}\n\n/* ── Cotraitants table ────────────────────────────────────────────────────── */\n\n.cotraitants-table-wrapper {\n  overflow-x: auto;\n}\n\n.cotraitants-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 1.3rem;\n}\n\n.cotraitants-table thead tr {\n  background-color: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.cotraitants-table th {\n  padding: 0.8rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #6b7280;\n  white-space: nowrap;\n  font-size: 1.2rem;\n}\n\n.cotraitants-table tbody tr {\n  /* border-bottom: 1px solid #f3f4f6; */\n  transition: background-color 0.15s;\n}\n\n.cotraitants-table tbody tr:hover {\n  background-color: #fdf4ef;\n}\n\n.cotraitants-table td {\n  padding: 0.8rem 1rem;\n  color: #374151;\n  vertical-align: middle;\n  font-size: 1.3rem;\n}\n\n.cotraitants-table td.td-entreprise {\n  font-weight: 500;\n}\n\n.cotraitants-table td.td-siret {\n  font-family: \"Courier New\", Courier, monospace;\n}\n\n.cotraitants-table td.td-email {\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cotraitants-table td.td-actions {\n  text-align: center;\n}\n\n.btn-delete-cotraitant {\n  background: none;\n  border: none;\n  color: #ef4444;\n  cursor: pointer;\n  font-size: 1.6rem;\n  padding: 0.2rem 0.4rem;\n  border-radius: 4px;\n  transition: background 0.15s;\n}\n\n.btn-delete-cotraitant:hover {\n  background: #fef2f2;\n}\n\n.retirer-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.4rem;\n  color: #ef4444;\n  padding: 0.2rem;\n  transition: opacity 0.15s;\n}\n\n.retirer-btn:hover {\n  opacity: 0.7;\n}\n\n/* ── Groupement footer ───────────────────────────────────────────────────── */\n\n.groupement-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  padding: 1.2rem;\n  border-top: 1px solid #f3f4f6;\n  flex-wrap: wrap;\n}\n\n.convention-inline {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.convention-inline > .button {\n  align-self: flex-start;\n}\n\n/* ── Bloc convention de groupement ──────────────────────────────────────── */\n\n.convention-bloc {\n  padding: 1.2rem 0;\n  margin: 0 0 0.75rem 0;\n  border-top: 1px solid #f3f4f6;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.convention-bloc-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.required-star {\n  color: #ef4444;\n  font-size: 1.4rem;\n}\n\n.convention-model-link {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: 1.2rem;\n  color: #f97316;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.convention-model-link:hover {\n  color: #ea6d0a;\n}\n\n.convention-doc-area {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.convention-doc-card {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.8rem 1.2rem;\n  background-color: rgba(215, 217, 217, 0.2);\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  transition:\n    transform 0.15s,\n    box-shadow 0.15s,\n    background-color 0.15s;\n  min-width: 220px;\n}\n\n.convention-doc-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);\n  background-color: rgba(215, 217, 217, 0.35);\n}\n\n.convention-doc-icon {\n  font-size: 1.8rem;\n  flex-shrink: 0;\n}\n\n.convention-doc-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.convention-doc-name {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #111827;\n  word-break: break-all;\n}\n\n.convention-doc-date {\n  font-size: 1.1rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n.convention-buttons {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-right: auto;\n}\n\n.convention-groupement-hint {\n  font-size: 0.8rem;\n  color: #9ca3af;\n}\n\n.convention-signee-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  background-color: #dcfce7;\n  color: #16a34a;\n  font-size: 1.2rem;\n  font-weight: 600;\n  padding: 0.3rem 0.8rem;\n  border-radius: 50px;\n}\n\n.convention-groupement-filename {\n  font-size: 0.875rem;\n  color: #374151;\n  font-weight: 500;\n}\n\n.convention-groupement-file-input {\n  display: none;\n}\n\n/* ── Preview modal convention signée ────────────────────────────────────── */\n\n.convention-preview-panel {\n  background: #ffffff;\n  border-radius: 10px;\n  width: 90vw;\n  max-width: 900px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.convention-preview-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.convention-preview-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #111827;\n  word-break: break-all;\n}\n\n.convention-preview-iframe {\n  flex: 1;\n  border: none;\n  min-height: 60vh;\n}\n\n.convention-preview-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.choix-lots-field {\n  padding: 1.2rem 1.5rem;\n  /* border-bottom: 1px solid #f3f4f6; */\n  position: relative;\n  z-index: 10;\n  overflow: visible;\n}\n\n.choix-lots-field:last-child {\n  border-bottom: none;\n}\n\n.field-label {\n  display: block;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.75rem;\n}\n\n.select-field {\n  width: 100%;\n  max-width: 400px;\n  padding: 0.75rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 1.4rem;\n  color: #374151;\n  background: #ffffff;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.select-field:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.select-disabled {\n  background: #f9fafb;\n  cursor: not-allowed;\n  color: #6b7280;\n}\n\n/* ── Dropdown lots géographiques ─────────────────────────────────────── */\n\n.lots-dropdown {\n  position: relative;\n}\n\n.lots-dropdown-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 400px;\n  padding: 0.75rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 1.4rem;\n  color: #374151;\n  background: #ffffff;\n  cursor: pointer;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.lots-dropdown-trigger:hover {\n  border-color: #f97316;\n}\n\n.lots-dropdown-trigger:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.lots-geo-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 2px;\n  max-height: 420px;\n  overflow-y: auto;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 0.75rem;\n  background: #ffffff;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.lots-geo-list-disabled {\n  background: #f9fafb;\n  cursor: not-allowed;\n}\n\n.lot-geo-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.4rem;\n  color: #374151;\n  cursor: pointer;\n}\n\n.lot-geo-option input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  accent-color: #f97316;\n}\n\n.lots-count {\n  font-size: 1.3rem;\n  color: #6b7280;\n  margin: 3.5rem 0 0.5rem 0;\n}\n\n.lots-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.lot-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background-color: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 9999px;\n  font-size: 1.2rem;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: background-color 0.15s;\n}\n\n.lot-chip:hover {\n  background-color: #e5e7eb;\n}\n\n.lot-chip-remove {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0 0.1rem;\n  line-height: 1;\n  font-weight: 700;\n  transition: color 0.15s;\n}\n\n.lot-chip-remove:hover {\n  color: #ef4444;\n}\n\n/* ── Lots géo — groupement région (lot 1xx) ──────────────────────────────── */\n\n.lot-geo-option-all {\n  font-weight: 600;\n  /* border-bottom: 1px solid #f3f4f6; */\n  padding-bottom: 0.5rem;\n  margin-bottom: 0.25rem;\n}\n\n.lots-geo-region-group {\n  /* border-bottom: 1px solid #f3f4f6; */\n  padding-bottom: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.lots-geo-region-group:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.lots-geo-region-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #374151;\n  cursor: pointer;\n  padding: 0.35rem 0;\n}\n\n.lots-geo-region-header input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  accent-color: #f97316;\n  flex-shrink: 0;\n}\n\n.lots-geo-region-nom {\n  flex: 1;\n}\n\n.lots-geo-region-count {\n  font-size: 1.2rem;\n  font-weight: 400;\n  color: #9ca3af;\n}\n\n.lots-geo-region-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.lots-geo-region-indent {\n  padding-left: 1.75rem;\n  font-size: 1.3rem;\n  color: #6b7280;\n}\n\n/* ── Offre technique ──────────────────────────────────────────────────────── */\n\n.critere-block {\n  display: flex;\n  flex-direction: column;\n  padding: 1.2rem 1.5rem;\n  /* border-bottom: 1px solid #f3f4f6; */\n}\n\n.critere-block:last-of-type {\n  border-bottom: none;\n}\n\n.critere-label {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #111827;\n  display: block;\n  margin-bottom: 0.8rem;\n}\n\n.critere-textarea {\n  width: 100%;\n  min-height: 120px;\n  padding: 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1.4rem;\n  color: #374151;\n  background-color: #ffffff;\n  resize: vertical;\n  font-family: inherit;\n  line-height: 1.6;\n  box-sizing: border-box;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.critere-textarea:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.critere-textarea-disabled {\n  background: #f9fafb;\n  cursor: not-allowed;\n  color: #6b7280;\n}\n\n.char-counter {\n  display: block;\n  text-align: right;\n  font-size: 1.2rem;\n  color: #9ca3af;\n  margin-top: 0.25rem;\n}\n\n/* ── Commission warning ──────────────────────────────────────────────────── */\n\n.commission-warning {\n  margin: 1.25rem 1.5rem;\n  padding: 1.2rem 1.6rem;\n  background-color: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 8px;\n  font-size: 1.3rem;\n  color: #92400e;\n  line-height: 1.6;\n}\n\n/* ── Toggle prix identiques ──────────────────────────────────────────────── */\n\n.prix-toggle-wrapper {\n  padding: 1rem 1.5rem;\n  /* border-bottom: 1px solid #f3f4f6; */\n}\n\n.prix-toggle-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.4rem;\n  color: #374151;\n}\n\n.prix-toggle-input {\n  width: 16px;\n  height: 16px;\n  accent-color: #f97316;\n  cursor: pointer;\n}\n\n/* ── Articles table ──────────────────────────────────────────────────────── */\n\n.candidature-detail-container .articles-table-wrapper {\n  overflow-x: auto;\n  padding: 1.2rem 1.5rem;\n}\n\n.candidature-detail-container .articles-table {\n  min-width: 1200px;\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 1.3rem;\n}\n\n.candidature-detail-container .articles-table thead tr {\n  background-color: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.candidature-detail-container .articles-table th {\n  padding: 0.8rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n  vertical-align: bottom;\n}\n\n/* Colonnes Prix : autoriser le retour à la ligne */\n.candidature-detail-container .articles-table th:nth-child(7),\n.candidature-detail-container .articles-table th:nth-child(8),\n.candidature-detail-container .articles-table th:nth-child(9) {\n  white-space: normal;\n  min-width: 120px;\n  text-align: center;\n}\n\n.candidature-detail-container .articles-table th small {\n  font-weight: 400;\n  color: #6b7280;\n  font-size: 1.1rem;\n}\n\n.candidature-detail-container .articles-table td {\n  padding: 0.8rem 1rem;\n  color: #374151;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n/* Colonne Ref : compacte */\n.candidature-detail-container .articles-table th:nth-child(1),\n.candidature-detail-container .articles-table td:nth-child(1) {\n  width: 2.5rem;\n  text-align: center;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n}\n\n/* Colonne Article : prend l'espace restant, tronque si trop long */\n.candidature-detail-container .articles-table th:nth-child(2) {\n  white-space: normal;\n}\n\n.candidature-detail-container .articles-table td:nth-child(2) {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Colonne Description : ajustée au bouton */\n.candidature-detail-container .articles-table th:nth-child(3),\n.candidature-detail-container .articles-table td:nth-child(3) {\n  width: 130px;\n  min-width: 130px;\n  text-align: center;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n}\n\n/* Colonnes Seuil A, Seuil B : compactes */\n.candidature-detail-container .articles-table th:nth-child(4),\n.candidature-detail-container .articles-table td:nth-child(4),\n.candidature-detail-container .articles-table th:nth-child(5),\n.candidature-detail-container .articles-table td:nth-child(5) {\n  width: 75px;\n  min-width: 75px;\n  text-align: center;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n}\n\n/* Colonne Unité : compacte */\n.candidature-detail-container .articles-table th:nth-child(6),\n.candidature-detail-container .articles-table td:nth-child(6) {\n  width: 65px;\n  min-width: 65px;\n  text-align: center;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n}\n\n.candidature-detail-container .articles-table tbody tr {\n  /* border-bottom: 1px solid #f3f4f6; */\n}\n\n.candidature-detail-container .articles-table tbody tr:hover {\n  background-color: #fdf4ef;\n}\n\n.prix-input {\n  width: 80px;\n  padding: 4px 6px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 1.2rem;\n  color: #374151;\n  text-align: right;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.prix-input:disabled {\n  background: #f9fafb;\n  cursor: not-allowed;\n  color: #9ca3af;\n}\n\n.prix-input:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n/* Cellule prix : input + € */\n.prix-input-cell {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.prix-input-cell__suffix {\n  color: #6b7280;\n  font-size: 1.2rem;\n}\n\n/* ── Accordéon ───────────────────────────────────────────────────────────── */\n\n/* ── Bouton \"Voir les détails\" (colonne Description) ─────────────────────── */\n\n.btn-voir-details {\n  background-color: #595959;\n  color: #ffffff;\n  border: none;\n  border-radius: 20px;\n  padding: 4px 10px;\n  font-size: 1.2rem;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.15s;\n}\n\n.btn-voir-details:hover {\n  background-color: #1f2937;\n}\n\n/* ── Accordéon ───────────────────────────────────────────────────────────── */\n\n.accordeons-list {\n  padding: 1rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.accordion {\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.accordion-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  background: #ffffff;\n  border: none;\n  cursor: pointer;\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #374151;\n  width: 100%;\n  text-align: left;\n  transition: background-color 0.15s;\n}\n\n.accordion-header:hover {\n  background-color: #fdf4ef;\n}\n\n/* Chevron icône dans accordéon */\n.accordion-chevron {\n  width: 20px;\n  height: 20px;\n  fill: #6b7280;\n  transition: transform 0.25s ease;\n  flex-shrink: 0;\n}\n\n.accordion-chevron--open {\n  transform: rotate(180deg);\n}\n\n.accordion-body {\n  /* border-top: 1px solid #e5e7eb; */\n  background: #fcfcfc;\n}\n\n/* ── Modal (réutilisation des styles de DashboardCandidatures) ─────────── */\n\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-panel {\n  background: #ffffff;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 640px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.4rem 1.8rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h2 {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.modal-body {\n  overflow-y: auto;\n  padding: 1.4rem 1.8rem;\n}\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 1.2rem 1.8rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* ── Inviter Modal (Story 8.5) ──────────────────────────────────────────── */\n\n.inviter-modal {\n  max-width: 580px;\n}\n\n.inviter-modal .modal-body {\n  overflow: visible;\n}\n\n.inviter-error {\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  color: #b91c1c;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n}\n\n.inviter-section-label {\n  display: block;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.inviter-search-wrapper {\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.inviter-search-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 1.3rem;\n  color: #374151;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    sans-serif;\n  transition: border-color 0.15s;\n}\n\n.inviter-search-input:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.inviter-search-spinner {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: inviterSpin 0.7s linear infinite;\n  pointer-events: none;\n}\n\n.inviter-search-results {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  z-index: 10000;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.inviter-search-result-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 14px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 1.3rem;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    sans-serif;\n  transition: background 0.12s;\n}\n\n.inviter-search-result-item:hover {\n  background: #fff7ed;\n}\n\n.inviter-result-nom {\n  font-size: 1.3rem;\n  color: #374151;\n  font-weight: 500;\n}\n\n.inviter-result-siret {\n  font-size: 1.1rem;\n  color: #9ca3af;\n  margin-left: auto;\n  font-family: monospace;\n}\n\n.inviter-search-empty {\n  padding: 10px 14px;\n  font-size: 1.3rem;\n  color: #9ca3af;\n}\n\n.inviter-membres-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 0.5rem;\n}\n\n.inviter-membres-count {\n  font-size: 1.2rem;\n  color: #6b7280;\n  margin: 0 0 4px;\n}\n\n.inviter-membre-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.inviter-membre-nom {\n  font-size: 1.3rem;\n  color: #374151;\n  font-weight: 500;\n  flex: 1;\n}\n\n.inviter-membre-siret {\n  font-size: 1.1rem;\n  color: #9ca3af;\n  font-family: monospace;\n}\n\n.inviter-membre-remove {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  color: #9ca3af;\n  padding: 0 4px;\n  border-radius: 4px;\n  transition:\n    color 0.15s,\n    background 0.15s;\n  flex-shrink: 0;\n}\n\n.inviter-membre-remove:hover {\n  color: #dc2626;\n  background: #fef2f2;\n}\n\n@keyframes inviterSpin {\n  from {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  to {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n\n/* ── Statut membre groupement ────────────────────────────────────────────── */\n\n.member-status {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 1.2rem;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.member-status--accepted {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.member-status--pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n/* ── Loading / Error ─────────────────────────────────────────────────────── */\n\n.detail-loading,\n.detail-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem;\n  gap: 1rem;\n  color: #6b7280;\n  font-size: 1.3rem;\n}\n\n.spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ── Placeholder onglets non implémentés ─────────────────────────────────── */\n\n.tab-placeholder {\n  text-align: center;\n  padding: 4rem;\n  color: #9ca3af;\n  font-size: 1.4rem;\n  background: #f9fafb;\n  border: 1px dashed #d1d5db;\n  border-radius: 0.5rem;\n  margin: 0;\n}\n\n/* ── Soumission (Story 8.9) ──────────────────────────────────────────────── */\n\n.soumission-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.soumission-badge-soumise {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #dcfce7;\n  color: #15803d;\n  font-weight: 600;\n  font-size: 1.3rem;\n  padding: 0.75rem 1.25rem;\n  border-radius: 0.5rem;\n  border: 1px solid #bbf7d0;\n}\n\n.soumission-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  padding: 1rem 1.25rem;\n}\n\n.soumission-block-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.soumission-block-title {\n  font-weight: 600;\n  font-size: 1.3rem;\n  color: #374151;\n}\n\n.soumission-profils-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.soumission-profil-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.25rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 0.375rem;\n}\n\n.soumission-profil-item.ok {\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.soumission-profil-item.ko {\n  background: #fef2f2;\n  color: #991b1b;\n}\n\n.soumission-profil-nom {\n  flex: 1;\n}\n\n.soumission-profil-pct {\n  font-weight: 600;\n  min-width: 3rem;\n  text-align: right;\n}\n\n.soumission-profil-icon {\n  font-weight: 700;\n  font-size: 1.1rem;\n  min-width: 1.2rem;\n  text-align: center;\n}\n\n/* ── Feedback inline après sauvegarde ───────────────────────────────────── */\n\n/* ── Section Génération du contrat (placeholder) ─────────────────────────── */\n\n.generation-contrat-placeholder {\n  min-height: 80px;\n  background-color: #f9fafb;\n  border-radius: 6px;\n}\n\n/* ── Feedback inline après sauvegarde ───────────────────────────────────── */\n\n.save-msg {\n  font-size: 1.15rem;\n  font-weight: 500;\n  padding: 0.25rem 0.75rem;\n  border-radius: 0.375rem;\n  animation: fadeInOut 3s ease forwards;\n}\n\n.save-msg-ok {\n  color: #166534;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n}\n\n.save-msg-err {\n  color: #991b1b;\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n}\n\n@keyframes fadeInOut {\n  0% {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  10% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n/* ── Checklist pré-soumission ───────────────────────────────────────────── */\n\n.soumission-checklist {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.soumission-check-item {\n  display: flex;\n  align-items: baseline;\n  gap: 0.6rem;\n  font-size: 1.25rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 0.375rem;\n}\n\n.soumission-check-item.ok {\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.soumission-check-item.ko {\n  background: #fef2f2;\n  color: #991b1b;\n}\n\n.soumission-check-item.loading {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n.soumission-check-icon {\n  font-weight: 700;\n  font-size: 1.1rem;\n  min-width: 1.2rem;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.soumission-check-label {\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.soumission-check-detail {\n  font-size: 1.1rem;\n  opacity: 0.8;\n}\n\n.soumission-alert {\n  color: #b91c1c;\n  font-size: 1.2rem;\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  border-radius: 0.375rem;\n  padding: 0.6rem 1rem;\n  margin: 0;\n}\n\n.soumission-conditions {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  font-size: 1.3rem;\n  color: #374151;\n  cursor: pointer;\n  line-height: 1.5;\n}\n\n.soumission-conditions input[type=\"checkbox\"] {\n  margin-top: 0.2rem;\n  width: 1.1rem;\n  height: 1.1rem;\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: #f97316;\n}\n\n.cgu-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #f97316;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: inherit;\n  font-family: inherit;\n}\n\n.cgu-link:hover {\n  color: #ea580c;\n}\n\n.cgu-required-star {\n  color: #ef4444;\n  font-weight: 700;\n}\n\n.tab-content {\n  gap: 2rem;\n  padding: 2rem 0;\n}\n\n/* ===== Story 13.6 — Détection prix manquants ============================= */\n\n.article-row--incomplete {\n  border-left: 3px solid #ef4444;\n  background-color: #fef2f2;\n}\n\n.prix-completion-counter {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  color: #6b7280;\n  margin-bottom: 1rem;\n  padding: 0.5rem 0.75rem;\n  background: #f9fafb;\n  border-radius: 0.375rem;\n}\n\n.prix-manquants {\n  color: #ef4444;\n  font-weight: 500;\n}\n\n.btn-scroll-manquant {\n  background: none;\n  border: none;\n  color: #3b82f6;\n  cursor: pointer;\n  font-size: 0.85rem;\n  text-decoration: underline;\n  padding: 0;\n}\n\n.accordion-badge {\n  font-size: 1.2rem;\n  margin-left: auto;\n  margin-right: 0.5rem;\n  font-weight: 500;\n}\n\n/* ── Forfait & prix dégressifs ───────────────────────────────────────────── */\n\n.article-row--warning {\n  border-left: 3px solid #f59e0b;\n  background-color: #fffbeb;\n}\n\n.article-row--error {\n  border-left: 3px solid #ef4444;\n  background-color: #fef2f2;\n}\n\n.prix-input--warning {\n  border-color: #f59e0b !important;\n  background-color: #fffbeb !important;\n}\n\n.prix-input--error {\n  border-color: #ef4444 !important;\n  background-color: #fef2f2 !important;\n}\n\n/* Input nom signataire (popup dépôt) */\n.nom-signataire-input {\n  width: 100%;\n  padding: 0.4rem 0.6rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1.2rem;\n  color: #374151;\n}\n\n.nom-signataire-input:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);\n}\n\n/* Bandeau d'etat d'une candidature annulee.\n   La largeur vient de son parent (.suivi-de-commande-content) : la banniere est\n   rendue DANS le conteneur des sections, elle n'a donc aucune geometrie propre.\n   Il ne reste qu'un espacement vertical. */\n/* Bandeau d'etat en tete des sections (annulation, depot hors delai).\n   Ne porte QUE l'espacement : la largeur vient du conteneur parent\n   .suivi-de-commande-content, jamais d'une constante recopiee ici. */\n.candidature-etat-banner {\n  margin-top: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
